import {themes} from "../../../styles/themes";
import {
  sortByKey,
  getPartidoInfo,
  getCamaraInfo,
  tooltipPartidoYDato,
  getLogo,
} from "../../../commons/js/util";
import "echarts/lib/component/tooltip";
import "echarts/lib/chart/pie";
import "echarts/lib/component/graphic";
import "echarts/lib/component/title";
import { position } from "../../../utils/tooltipPosition";
import { level, curulesEleccion, eleccion } from "../../../resources/constantes.json";

const convocatoria = "act";

function getData(data, nomenclator, eleccionID, t, totalCurules) {
  let parsedData = [], camaraData = [];
  const sinInfo = data.totales[convocatoria].pmesesc === "0%" ;

  const sinInfoData =  {
    name: t("sinInformacion"),
    value: totalCurules,
    itemStyle: {
      borderColor: themes.color.sinInfo,
      color: themes.color.sinInfo,
    },
    tipData: {
      showTooltip: true,
      sinInfo: true,
      noModal: true,
    },
    emphasis: {
      show: false,
      itemStyle: {
        borderColor: themes.color.sinInfo,
        color: themes.color.sinInfo,
      },
    },
  };

  /********** Insertamos las camaras **************** */
  let camara;
  for(let i = 0; i < data.camaras.length; i++){
    const currentCam = data.camaras[i];
    const cam = getCamaraInfo(
      currentCam.cam,
      nomenclator.nomAmbitos[eleccionID].cam
    );
    camara = {
      name: cam.ca,
      value: Number(currentCam.cargtota),
      cursor: "pointer",
      itemStyle: {
        borderColor: cam.co,
        color: cam.co,
      },
      tipData: {
        tipoCargo:
          Number(currentCam.carg) === 1 ? t("curul") : t("curules"),
        showTooltip: true,
        parName: cam.ca,
        convocatoria,
      },
    }
    camaraData.push(camara);
    if (sinInfo) {
      parsedData = [
        sinInfoData
      ];
    }else{
      let partido;
      const partotabla = currentCam.partotabla;
      for (let index = 0; index < partotabla.length; index++) {
        const el = partotabla[index][convocatoria];
        if (Number(el.cargElectos) === 0) continue;
        const par = getPartidoInfo(
          el.codpar,
          nomenclator.partidos
        );
        partido = {
          name: par.nombre,
          value: Number(el.cargElectos),
          cursor: "pointer",
          vot: el.vot,
          dataTestId: `data.partotabla[${index}].${convocatoria}.cargElectos`,
          itemStyle: {
            borderColor: "#fff",
            color: par.color,
          },
          tipData: {
            tipoCargo:
              Number(el.cargElectos) === 1 ? t("curul") : t("curules"),
            showTooltip: true,
            codpar: par.codpar,
            parName: par.nombre,
            convocatoria,
          },
        };
        parsedData.push(partido);
      }
      /** Añadimos los cargos sin asignar por camara */
      const sinAsignarCamara = Number(currentCam.cargtota) - Number(currentCam.cargElectos);
      const sinAsignar = {
        name: cam.ca + " <br/>" + t("sinAsignar"),
        value: sinAsignarCamara,
        itemStyle: {
          borderColor: themes.color.sinAsignar,
          color: themes.color.sinAsignar,
        },
        tipData: {
          tipoCargo: sinAsignarCamara === 1 ? t("curul") : t("curules"),
          showTooltip: true,
          noModal: true,
        },
      };
      parsedData.push(sinAsignar);
    }
  }
  // Quitamos ordenacion ya que los partidos vienen ordenados por cargos en los datos y ademas los cargos sin asignar sueñles ser mayores
  // parsedData = sortByKey(parsedData, "value", "vot");

  let total = Number(totalCurules);
  if(eleccionID === eleccion.camara){
    //Añadimos los cargos de la eleccion Citrep
    const curulesCitrep = {
      name: t("citrep"),
      value: Number(curulesEleccion[eleccion["citrep"]]),
      itemStyle: {
        borderColor: themes.color.circPaz,
        color: themes.color.circPaz,
      },
      tipData: {
        showTooltip: true,
        tipoCargo: t("curules"),
        noModal: true,
      },
    };
    parsedData.push(curulesCitrep);
    camaraData.push(curulesCitrep);
    total += Number(curulesEleccion[eleccion["citrep"]]);
  }

  /*
   *
   Añadimos los semicírculos "invisibles" para proporcionar nuestro hemiciclo.
   */
  const invisibles = {
    value: total,
    itemStyle: {
      opacity: 0,
    },
    tipData: {
      showTooltip: false,
      noModal: true,
    },
  }
  parsedData.push(invisibles);
  camaraData.push(invisibles);
  return { partidos: parsedData, camaras: camaraData };
}

const seriesBaseOption = {
  type: "pie",
  center: ["50%", "85%"],
  startAngle: "180",
  selectedMode: false,
  hoverAnimation: false,
  avoidLabelOverlap: false,
  label: {
    normal: {
      show: false,
    },
  },
  labelLine: {
    show: false,
  },
};

export function getOption(unparsedData, nomen, eleccionID, isSmall, isDesktop, t, lang, nombreCitrep) {
  const totalCurules = unparsedData.totales[convocatoria].cargtota;
  const data = getData(unparsedData, nomen, eleccionID, t, totalCurules);
  const pos = position();
  const series = [
    {
      ...seriesBaseOption,
      name: t("resultCamaras"),
      data: data.partidos,
    },
    {
      ...seriesBaseOption,
      name: t("ResultPartidos"),
      data: data.camaras,
    },
  ];

  return {
    baseOption: {
      series: series,
      title: formatTitle(totalCurules, eleccionID, isSmall, t, nombreCitrep),
      textStyle: {
        fontFamily: "Lato",
      },
      tooltip: {
        show: isDesktop,
        trigger: "item",
        confine: true,
        padding: 0,
        position: (point, params, dom, rect) => {
          return pos.current("top", rect, dom);
        },
        formatter: function(params) {
          let result;
          const data = params.data;
          if (data && data.tipData.showTooltip)
            if (!data.tipData.sinInfo)
              result = tooltipPartidoYDato(
                null,
                data.tipData.color ?? data.itemStyle.color,
                data.name,
                data.value,
                data.tipData.tipoCargo,
                null,
                null,
                null,
                null,
                getLogo(data.tipData.codpar, lang, data.tipData.convocatoria)
              );
            else
              result = tooltipPartidoYDato(
                null,
                data.itemStyle.color,
                data.name
              );
          return result;
        },
      },
    },
    media: [
      {
        query: { minWidth: 580 },
        option: {
          title: [
            {
              bottom: 10,
            },
          ],
          series: [
            {
              radius: [170, 170 + 100],
            },
            {
              radius: [280, 280 + 10],
            },
          ],
        }
      },
      {
        query: { maxWidth: 580, minWidth: 480 },
        option: {
          title: [
            {
              bottom: -20,
              textStyle: {fontSize: 12}
            },
          ],
          series: [
            {
              radius: [110, 110 + 100],
            },
            {
              radius: [220, 220 + 10],
            },
          ],
        }
      },
      {
        query: { maxWidth: 450 },
        option: {
          title: [
            {
              bottom: -50,
            },
          ],
          series: [
            {
              radius: [80, 80 + 50],
            },
            {
              radius: [140, 140 + 10],
            },
          ],
        }
      },
    ],
  };
}

const formatTitle = (totalCurules, eleccionID, isSmall, t, nombreCitrep) => {
  let title = "";
  if(eleccionID === eleccion.camara){
    title = {
      text: [
        `{a|${totalCurules}}`,
        `{b| + ${curulesEleccion[eleccion.citrep]} (${nombreCitrep})}`,
      ].join("\n"),
      textStyle: {
        position: "inside",
        rich: {
          a: {
            fontWeight: 900,
            color: "#1C4183",
            textBorderColor: "transparent",
            lineHeight: 28,
            fontSize: isSmall ? 26 : 32,
            align: "center",
            padding: [200, 0, 20, 0],
          },
          b: {
            fontWeight: 600,
            color: themes.color.circPaz,
            textBorderColor: "transparent",
            fontSize: isSmall ? 10 : 14,
            lineHeight: isSmall ? 14 : 20,
            align: "center",
            padding: [180, 0, 0, 0],
          },
        },
      },
      textAlign: "center",
      left: "50%",
      top: "50%",
    }
  }
  return title;
}

const breakAtFirstWord = s => {
  const words = s.split(" ");
  return [words.slice(0, 1).join(" "), words.slice(1).join(" ")].join("\n");
};
